/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, clock: NonNullable<unknown> }} Quarter_RemainingInputs */

const th_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ควอเตอร์ ${i?.n} · เหลือ ${i?.clock}`)
};

const en_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quarter ${i?.n} · ${i?.clock} remaining`)
};

const ja_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.n}クォーター · 残り${i?.clock}`)
};

const zh_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.n} 节 · 还剩 ${i?.clock}`)
};

const es_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuarto ${i?.n} · quedan ${i?.clock}`)
};

const pt_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}º quarto · faltam ${i?.clock}`)
};

const id_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kuarter ${i?.n} · sisa ${i?.clock}`)
};

const fr_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quart-temps ${i?.n} · ${i?.clock} restantes`)
};

const tl_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ika-${i?.n} quarter · ${i?.clock} pa`)
};

const vi_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hiệp ${i?.n} · còn ${i?.clock}`)
};

const ko_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}쿼터 · ${i?.clock} 남음`)
};

const de_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}. Viertel · noch ${i?.clock}`)
};

const ru_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}-я четверть · осталось ${i?.clock}`)
};

const tr_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}. çeyrek · ${i?.clock} kaldı`)
};

const it_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}° quarto · ${i?.clock} alla fine`)
};

const pl_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}. kwarta · pozostało ${i?.clock}`)
};

const uk_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}-та чверть · лишилося ${i?.clock}`)
};

const hi_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} क्वार्टर · ${i?.clock} शेष`)
};

const ar_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الربع ${i?.n} · بقي ${i?.clock}`)
};

const ms_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suku ke-${i?.n} · ${i?.clock} lagi`)
};

const bn_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} নম্বর কোয়ার্টার · ${i?.clock} বাকি`)
};

const zh_tw2_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.n} 節 · 還剩 ${i?.clock}`)
};

const zh_hk2_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.n} 節 · 還剩 ${i?.clock}`)
};

const ur_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} کوارٹر · ${i?.clock} باقی`)
};

const fa_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`کوارتر ${i?.n} · ${i?.clock} مانده`)
};

const sw_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Robo ya ${i?.n} · ${i?.clock} zimebaki`)
};

const nl_quarter_remaining = /** @type {(inputs: Quarter_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}e periode · nog ${i?.clock}`)
};

/**
* | output |
* | --- |
* | "Quarter {n} · {clock} remaining" |
*
* @param {Quarter_RemainingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const quarter_remaining = /** @type {((inputs: Quarter_RemainingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quarter_RemainingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_quarter_remaining(inputs)
	if (locale === "ja") return ja_quarter_remaining(inputs)
	if (locale === "zh") return zh_quarter_remaining(inputs)
	if (locale === "es") return es_quarter_remaining(inputs)
	if (locale === "pt") return pt_quarter_remaining(inputs)
	if (locale === "id") return id_quarter_remaining(inputs)
	if (locale === "fr") return fr_quarter_remaining(inputs)
	if (locale === "tl") return tl_quarter_remaining(inputs)
	if (locale === "vi") return vi_quarter_remaining(inputs)
	if (locale === "ko") return ko_quarter_remaining(inputs)
	if (locale === "de") return de_quarter_remaining(inputs)
	if (locale === "ru") return ru_quarter_remaining(inputs)
	if (locale === "tr") return tr_quarter_remaining(inputs)
	if (locale === "it") return it_quarter_remaining(inputs)
	if (locale === "pl") return pl_quarter_remaining(inputs)
	if (locale === "uk") return uk_quarter_remaining(inputs)
	if (locale === "hi") return hi_quarter_remaining(inputs)
	if (locale === "ar") return ar_quarter_remaining(inputs)
	if (locale === "ms") return ms_quarter_remaining(inputs)
	if (locale === "bn") return bn_quarter_remaining(inputs)
	if (locale === "zh-TW") return zh_tw2_quarter_remaining(inputs)
	if (locale === "zh-HK") return zh_hk2_quarter_remaining(inputs)
	if (locale === "ur") return ur_quarter_remaining(inputs)
	if (locale === "fa") return fa_quarter_remaining(inputs)
	if (locale === "sw") return sw_quarter_remaining(inputs)
	if (locale === "nl") return nl_quarter_remaining(inputs)
	return en_quarter_remaining(inputs)
});